export const DEFAULT_VALUES = {
	from: '',
	till: '',
	fromTime: '',
	tillTime: '',
	location: '',
	note: '',
};
